// extracted by mini-css-extract-plugin
export default {"formWarpper":"Form_formWarpper__l9usS","loadingtext":"Form_loadingtext__4Bwk3"};